// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__3r_Nt","Title":"Projects_Title__2T43D","ProjectFeature":"Projects_ProjectFeature__2p4cE"};